import { render } from "./Zhibo.vue?vue&type=template&id=7dec5bac&scoped=true"
import script from "./Zhibo.vue?vue&type=script&lang=js"
export * from "./Zhibo.vue?vue&type=script&lang=js"

import "./Zhibo.vue?vue&type=style&index=0&id=7dec5bac&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dec5bac"]])

export default __exports__